<template>
  <section class="contact-cta">
    <div class="container">
      <h2 class="cta-title">{{ t('home.contact.title') }}</h2>
      <button class="cta-button" @click="handleGetStarted">
        {{ t('home.contact.getStarted') }}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="22"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.5"
        >
          <polyline points="9 18 15 12 9 6"></polyline>
        </svg>
      </button>
    </div>
  </section>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'

const router = useRouter()
const { t } = useI18n()

const handleGetStarted = () => {
  router.push('/contact')
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Bitter:wght@300;400;500;600;700&family=Hind:wght@300;400;500;600;700&display=swap');

.contact-cta {
  background: linear-gradient(135deg, #2a2a2a 0%, #1a1a1a 100%);
  padding: 90px 0;
  text-align: center;
}

.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 50px;
}

.cta-title {
  font-size: 48px;
  font-weight: 700;
  color: white;
  margin-bottom: 40px;
  font-family: 'Bitter', serif;
  letter-spacing: 1px;
}

.cta-button {
  padding: 18px 45px;
  font-size: 30px;
  font-weight: 600;
  background-color: #d97f3e;
  color: white;
  border: none;
  border-radius: 35px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: 'Hind', sans-serif;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  box-shadow: 0 6px 20px rgba(217, 127, 62, 0.4);
}
</style>